import { TooltipDirective } from 'src/app/directives/tooltip.directive';
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  faCancel,
  faCheck,
  faClock,
  faClockRotateLeft,
  faEdit,
  faExternalLink,
  faEye,
  faHome,
  faPlaneArrival,
  faPlaneDeparture,
  faPlus,
  faTrash
} from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { EnumAcl } from '@simplyfly/shared';
import { EnumEnquiryType } from '@simplyfly/shared';
import { IEnquiryFlight } from '@simplyfly/shared';
import { getEnquiryFlightFlyTimeInMin } from 'src/app/interfaces/enquiry-flight.helpers';
import { IEnquiry } from '@simplyfly/shared';
import { IFbo } from '@simplyfly/shared';
import { getFboFullAddress } from 'src/app/interfaces/fbo.helpers';
import { IFlightChecklistTemplate } from '@simplyfly/shared';
import { IFlightChecklist } from '@simplyfly/shared';
import { getFinishedCheckOnTotalForFlight } from 'src/app/interfaces/flight-checklist.helpers';
import { convertMinutesToTime } from 'src/app/misc.utils';
import { AclService } from 'src/app/services/acl.service';
import { EnquiryFlightService } from 'src/app/services/enquiry-flights/enquiry-flights.service';
import { FboService } from 'src/app/services/fbos/fbos.service';
import { FlightChecklistTemplateService } from 'src/app/services/flight-checklist-templates/flight-checklist-templates.service';
import { FlightChecklistService } from 'src/app/services/flight-checklists/flight-checklists.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

import countries from '../../countries_fr.json';
import { ICrew } from '@simplyfly/shared';
import { CrewService } from 'src/app/services/crews/crews.service';
import { AirlineSupervisorService } from 'src/app/services/airline-supervisors/airline-supervisors.service';
import { IAirlineSupervisor } from '@simplyfly/shared';
import { AirportSupervisorService } from 'src/app/services/airport-supervisors/airport-supervisors.service';
import { IAirportSupervisor } from '@simplyfly/shared';
import { EnumEnquiryFlightWizardStep, EnquiryFlightEditComponent } from '../enquiry-flight-edit/enquiry-flight-edit.component';
import { IHandling } from '@simplyfly/shared';
import { getHandlingFullAddress } from 'src/app/interfaces/handling.helpers';
import { HandlingService } from 'src/app/services/handlings/handlings.service';
import { IAirport } from '@simplyfly/shared';
import { AirportService } from 'src/app/services/airports/airports.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { RouterLink } from '@angular/router';
import { EnquiryFlightChecklistComponent } from '../enquiry-flight-checklist/enquiry-flight-checklist.component';
import { EnquiryFlightAddComponent } from '../enquiry-flight-add/enquiry-flight-add.component';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-enquiry-flights-cards',
    templateUrl: './enquiry-flights-cards.component.html',
    styleUrls: ['./enquiry-flights-cards.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
      TooltipDirective,
      FaIconComponent,
      RouterLink,
      EnquiryFlightChecklistComponent,
      EnquiryFlightEditComponent,
      EnquiryFlightAddComponent,
      DatePipe,
      TranslateModule
    ]
})
export class EnquiryFlightsCardsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() loading = false;
  @Input() enquiry: IEnquiry | null = null;
  @Input() enquiryFlights: IEnquiryFlight[] = [];
  @Input() noDeleteBtn = false;
  @Input() noChecklistBtn = false;

  @ViewChild('modalChecklist', { static: false }) modalChecklistElement: ElementRef;
  @ViewChild('modalEnquiryFlightEdit', { static: false }) modalEnquiryFlightEditElement: ElementRef;
  @ViewChild('modalEnquiryFlightAdd', { static: false }) modalEnquiryFlightAddElement: ElementRef;

  EnumAcl = EnumAcl;
  EnumEnquiryType = EnumEnquiryType;

  getFinishedCheckOnTotalForFlight = getFinishedCheckOnTotalForFlight;
  convertMinutesToTime = convertMinutesToTime;
  getFboFullAddress = getFboFullAddress;
  getHandlingFullAddress = getHandlingFullAddress;
  getEnquiryFlightFlyTimeInMin = getEnquiryFlightFlyTimeInMin;

  faHome = faHome;
  faEdit = faEdit;
  faEye = faEye;
  faCancel = faCancel;
  faCheck = faCheck;
  faClockRotateLeft = faClockRotateLeft;
  faTrash = faTrash;
  faPlus = faPlus;

  faPlaneDeparture = faPlaneDeparture;
  faPlaneArrival = faPlaneArrival;
  faClock = faClock;
  faExternalLink = faExternalLink;

  countries: { [countryCode: string]: string } = countries;

  get dateLocale(): string {
    return this.translateService.currentLang === 'fr' ? 'fr' : 'en-US';
  }

  calendarDates: string[] = [];

  nbDaysDisplayed = 5;

  selectedFlight: IEnquiryFlight | null = null;

  flightChecklistTemplateByEnquiryType: { [enquiryType: string]: IFlightChecklistTemplate | null } =
    {};
  flightChecklistByEnquiryFlight: { [enquiryFlightId: string]: IFlightChecklist | null } = {};

  flightChecklistTemplate: IFlightChecklistTemplate | null = null;
  loadingFlightChecklistTemplate = false;

  flightChecklist: IFlightChecklist | null = null;
  loadingFlightChecklist = false;

  currentEnquiryFlightStep: EnumEnquiryFlightWizardStep = EnumEnquiryFlightWizardStep.aircraft;
  currentEnquiryFlight: IEnquiryFlight | null = null;

  fbosObj: { [id: string]: IFbo | null } = {};
  airportsObj: { [id: string]: IAirport | null } = {};
  handlingsObj: { [id: string]: IHandling | null } = {};
  crewsObj: { [id: string]: ICrew | null } = {};
  supervisorsObj: { [id: string]: IAirlineSupervisor | IAirportSupervisor | null } = {};
  supervisorSourceObj: { [id: string]: 'airport' | 'airline' } = {};
  loadedSupervisorAirportIds = new Set<string>();
  loadedSupervisorAirlineIds = new Set<string>();

  private subscriptions = new Subscription();
  private subscriptionFlightChecklist = new Subscription();

  constructor(
    private aclService: AclService,
    private enquiryFlightService: EnquiryFlightService,
    private loaderService: LoaderService,
    private flightChecklistTemplateService: FlightChecklistTemplateService,
    private flightChecklistService: FlightChecklistService,
    private fboService: FboService,
    private airportService: AirportService,
    private handlingService: HandlingService,
    private crewService: CrewService,
    private airlineSupervisorService: AirlineSupervisorService,
    private airportSupervisorService: AirportSupervisorService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.refreshChecklistAndTemplateFromEnquiryFlights();

    this.refreshAirportsForAllEnquiryFlights();
    this.refreshFbosForAllEnquiryFlights();
    this.refreshHandlingsForAllEnquiryFlights();
    this.refreshCrewsAndSupervisorsForAllEnquiryFlights();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.enquiryFlights) {
      this.refreshAirportsForAllEnquiryFlights();
      this.refreshFbosForAllEnquiryFlights();
      this.refreshHandlingsForAllEnquiryFlights();
    }

    this.refreshChecklistAndTemplateFromEnquiryFlights();
    this.refreshCrewsAndSupervisorsForAllEnquiryFlights();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.subscriptionFlightChecklist.unsubscribe();

    this.removeModal();
  }

  refreshFbosForAllEnquiryFlights(): void {
    for (const enquiryFlight of this.enquiryFlights) {
      for (const field of ['departFboId', 'arrivalFboId']) {
        if (enquiryFlight[field]) {
          this.loadFbo(enquiryFlight[field]);
        }
      }
    }
  }

  refreshAirportsForAllEnquiryFlights(): void {
    for (const enquiryFlight of this.enquiryFlights) {
      for (const field of ['airportDepartId', 'airportArrivalId']) {
        if (enquiryFlight[field]) {
          this.loadAirport(enquiryFlight[field]);
        }
      }
    }
  }

  refreshHandlingsForAllEnquiryFlights(): void {
    for (const enquiryFlight of this.enquiryFlights) {
      for (const field of ['departHandlingId', 'arrivalHandlingId']) {
        if (enquiryFlight[field]) {
          this.loadHandling(enquiryFlight[field]);
        }
      }
    }
  }

  loadAirport(airportId: string): void {
    if (typeof this.airportsObj[airportId] === 'undefined') {
      this.airportsObj[airportId] = null;

      this.subscriptions.add(
        this.airportService.getFromId(airportId).subscribe((airport: IAirport | null) => {
          this.airportsObj[airportId] = airport;
        })
      );
    }
  }

  refreshCrewsAndSupervisorsForAllEnquiryFlights(): void {
    for (const enquiryFlight of this.enquiryFlights) {
      if (enquiryFlight.airlineId) {
        this.loadCrewsForAirline(enquiryFlight.airlineId);
        this.loadSupervisorsForAirline(enquiryFlight.airlineId);
      }
      if (enquiryFlight.airportDepartId) {
        this.loadSupervisorsForAirport(enquiryFlight.airportDepartId);
      }
      if (enquiryFlight.airportArrivalId) {
        this.loadSupervisorsForAirport(enquiryFlight.airportArrivalId);
      }
    }
  }

  removeModal(): void {
    window.$(this.modalChecklistElement.nativeElement).modal('hide');
    window.$(this.modalEnquiryFlightEditElement.nativeElement).modal('hide');
    window.$(this.modalEnquiryFlightAddElement.nativeElement).modal('hide');
    window.$('body').removeClass('modal-open');
    window.$('.modal-backdrop').remove();
  }

  selectFlight(flight: IEnquiryFlight | null = null): void {
    this.selectedFlight = flight;
  }

  viewFlightChecklist(flight: IEnquiryFlight): void {
    this.selectFlight(flight);

    this.loadFlightChecklistAndTemplate();

    window.$(this.modalChecklistElement.nativeElement).modal('show');
  }

  hasAclAccess(id: EnumAcl): boolean {
    return this.aclService.hasAclAccess(id);
  }

  loadFlightChecklistAndTemplate(): void {
    if (this.selectedFlight) {
      if (this.subscriptionFlightChecklist) {
        this.subscriptionFlightChecklist.unsubscribe();
      }

      this.subscriptionFlightChecklist = new Subscription();

      this.loadFlightChecklistTemplate();
      this.loadFlightChecklist();
    }
  }

  private loadFlightChecklistTemplate(): void {
    if (this.selectedFlight) {
      this.loadingFlightChecklistTemplate = true;

      this.subscriptionFlightChecklist.add(
        this.flightChecklistTemplateService
          .getOneForEnquiryType(this.selectedFlight.enquiryType)
          .subscribe((flightChecklistTemplate: IFlightChecklistTemplate) => {
            this.flightChecklistTemplate = flightChecklistTemplate;

            if (this.flightChecklistTemplate) {
              this.flightChecklistTemplateByEnquiryType[this.flightChecklistTemplate.enquiryType] =
                this.flightChecklistTemplate;
            }

            this.loadingFlightChecklistTemplate = false;
          })
      );
    }
  }

  private loadFlightChecklist(): void {
    if (this.selectedFlight) {
      this.loadingFlightChecklist = true;

      this.subscriptionFlightChecklist.add(
        this.flightChecklistService
          .getForFlight(this.selectedFlight.id)
          .subscribe((flightChecklist: IFlightChecklist) => {
            this.flightChecklist = flightChecklist;

            if (this.flightChecklist) {
              this.flightChecklistByEnquiryFlight[this.selectedFlight.id] = this.flightChecklist;
            }

            this.loadingFlightChecklist = false;
          })
      );
    }
  }

  refreshChecklistAndTemplateFromEnquiryFlights(): void {
    if (this.enquiryFlights) {
      for (const enquiryFlight of this.enquiryFlights) {
        this.loadChecklistTemplate(enquiryFlight.enquiryType);
        this.loadChecklist(enquiryFlight.id);
      }
    }
  }

  loadChecklistTemplate(enquiryType: EnumEnquiryType): void {
    if (typeof this.flightChecklistTemplateByEnquiryType[enquiryType] === 'undefined') {
      this.flightChecklistTemplateByEnquiryType[enquiryType] = null;

      this.subscriptions.add(
        this.flightChecklistTemplateService
          .getOneForEnquiryType(enquiryType)
          .subscribe((flightChecklistTemplate: IFlightChecklistTemplate) => {
            if (flightChecklistTemplate) {
              this.flightChecklistTemplateByEnquiryType[enquiryType] = flightChecklistTemplate;
            }
          })
      );
    }
  }

  loadChecklist(enquiryFlightId: string): void {
    if (typeof this.flightChecklistByEnquiryFlight[enquiryFlightId] === 'undefined') {
      this.flightChecklistByEnquiryFlight[enquiryFlightId] = null;

      this.subscriptions.add(
        this.flightChecklistService
          .getForFlight(enquiryFlightId)
          .subscribe((flightChecklist: IFlightChecklist) => {
            if (flightChecklist) {
              this.flightChecklistByEnquiryFlight[enquiryFlightId] = flightChecklist;
            }
          })
      );
    }
  }

  async deleteLeg(enquiryFlight: IEnquiryFlight): Promise<void> {
    if (
      confirm(
        this.translateService.instant('ENQUIRIES.CONFIRM_DELETE_LEG')
      )
    ) {
      this.loaderService.presentLoader();

      this.enquiryFlightService
        .delete(enquiryFlight.id)
        .then(async () => {
          await this.loaderService.hideLoaderOnSuccess();

        })
        .catch(async err => {
          await this.loaderService.hideLoaderOnFailure(err);
        });
    }
  }

  async addLeg(): Promise<void> {
    this.currentEnquiryFlight = null;
    this.currentEnquiryFlightStep = EnumEnquiryFlightWizardStep.aircraft;

    if (this.enquiryFlights.length) {
      if (this.modalEnquiryFlightAddElement.nativeElement) {
        window.$(this.modalEnquiryFlightAddElement.nativeElement).modal('show');
      }
    } else {
      if (this.modalEnquiryFlightEditElement.nativeElement) {
        window.$(this.modalEnquiryFlightEditElement.nativeElement).modal('show');
      }
    }
  }

  editLeg(enquiryFlight: IEnquiryFlight): void {
    this.currentEnquiryFlight = enquiryFlight;
    this.currentEnquiryFlightStep = EnumEnquiryFlightWizardStep.aircraft;

    if (this.modalEnquiryFlightEditElement.nativeElement) {
      window.$(this.modalEnquiryFlightEditElement.nativeElement).modal('show');
    }
  }

  loadFbo(fboId: string): void {
    if (typeof this.fbosObj[fboId] === 'undefined') {
      this.fbosObj[fboId] = null;

      this.subscriptions.add(
        this.fboService.getFromId(fboId).subscribe((fbo: IFbo | null) => {
          this.fbosObj[fboId] = fbo;
        })
      );
    }
  }

  loadHandling(handlingId: string): void {
    if (typeof this.handlingsObj[handlingId] === 'undefined') {
      this.handlingsObj[handlingId] = null;

      this.subscriptions.add(
        this.handlingService.getFromId(handlingId).subscribe((handling: IHandling | null) => {
          this.handlingsObj[handlingId] = handling;
        })
      );
    }
  }

  loadCrewsForAirline(airlineId: string): void {
    this.subscriptions.add(
      this.crewService.getForAirline(airlineId).subscribe((crews: ICrew[]) => {
        for (const crew of crews) {
          this.crewsObj[crew.id] = crew;
        }
      })
    );
  }

  loadSupervisorsForAirport(airportId: string): void {
    if (this.loadedSupervisorAirportIds.has(airportId)) {
      return;
    }
    this.loadedSupervisorAirportIds.add(airportId);

    this.subscriptions.add(
      this.airportSupervisorService.getForAirport(airportId).subscribe((supervisors: IAirportSupervisor[]) => {
        for (const supervisor of supervisors) {
          this.supervisorsObj[supervisor.id] = supervisor;
          this.supervisorSourceObj[supervisor.id] = 'airport';
        }
      })
    );
  }

  loadSupervisorsForAirline(airlineId: string): void {
    if (this.loadedSupervisorAirlineIds.has(airlineId)) {
      return;
    }
    this.loadedSupervisorAirlineIds.add(airlineId);

    this.subscriptions.add(
      this.airlineSupervisorService.getForAirline(airlineId).subscribe((supervisors: IAirlineSupervisor[]) => {
        for (const supervisor of supervisors) {
          if (!this.supervisorsObj[supervisor.id]) {
            this.supervisorsObj[supervisor.id] = supervisor;
            this.supervisorSourceObj[supervisor.id] = 'airline';
          }
        }
      })
    );
  }

  getSupervisorUrl(supervisorId: string): string {
    return this.supervisorSourceObj[supervisorId] === 'airport'
      ? '/admin/airport-supervisors/' + supervisorId
      : '/admin/airline-supervisors/' + supervisorId;
  }

  assignSelectedEnquiryFlight(enquiryFlightId: string): void {
    this.currentEnquiryFlight = null;

    for (const enquiryFlight of this.enquiryFlights) {
      if (enquiryFlight.id === enquiryFlightId) {
        this.currentEnquiryFlight = enquiryFlight;
        break;
      }
    }
  }
}
